import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import type { IPartnerDocumentSection } from '../../../../lib/documentsAndLinks'
import { countDocuments } from '../../lib/countDocuments'
import { DocumentsTreeLinks } from '../documentsTreeLinks/DocumentsTreeLinks'

import styles from './DocumentsTreeHeader.module.scss'

interface IProps {
  label?: string
  sections: IPartnerDocumentSection[]
}
const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks
export const DocumentsTreeHeader = ({ label, sections }: IProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.scope}>
        <h3>{label ?? <Translation span text={KEYS.navigation.root} />}</h3>
        <Translation
          span
          text={KEYS.treeDocuments.scopeSummary}
          replaceParams={[
            { key: '{total}', value: String(countDocuments(sections)) },
            { key: '{elt}', value: String(countDocuments(sections, 'elt')) },
            { key: '{qbr}', value: String(countDocuments(sections, 'qbr')) },
          ]}
        />
      </div>
      <DocumentsTreeLinks />
    </div>
  )
}
